class MobileDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.closest('details');
    this.summary = this.details.querySelector('summary');
    this.activeLink = this.querySelector('a.active');

    this.breakpoint = window.breakpoints.desktop;
    
    this.breakpoint.addEventListener('change', this.onMediaQueryChange.bind(this));
    this.onMediaQueryChange(this.breakpoint);
    
    [this.summary, this.activeLink].forEach(toggler => {
      toggler.addEventListener('click', this.onTogglerClick.bind(this));
    })
  }

  onMediaQueryChange(query) {
    if (query.matches) {
      this.open();
    } else {
      this.close();
    }
  }

  onTogglerClick(ev) {
    ev.preventDefault();
    if (this.breakpoint.matches) return; 
    
    this.details.toggleAttribute("open");
  }

  open() {
    this.details.toggleAttribute('open', true);
  }

  close() {
    this.details.toggleAttribute('open', false);
  }
}

customElements.define('mobile-dropdown', MobileDropdown);